<template>
  <article>
   <div class="filter mt-20 mb-20">
      <div class="ml-auto">
        <button class="blue-small-btn" @click="detailDialog = !detailDialog">新建</button>
      </div>
    </div>
    <el-table ref="dataTable" :data="lists" highlight-current-row v-loading="listLoading" style="width: 100%;" class="" height="700">
      <el-table-column prop="fcid" label="特征ID" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="category" label="特征名" width="" align="center" sortable>
      </el-table-column>
      <el-table-column prop="attributes" label="属性" width="" align="center" sortable>
      </el-table-column>
      <el-table-column label="操作" width="250" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="flex jcc">
            <button class="blue-small-btn" @click="editDetail(scope.$index)">编辑</button>
            <button class="blue-small-btn ml-20" @click="editAttribute(scope.$index)">创建属性</button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="特征编辑" :visible.sync="detailDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">特征ID</div>
            <el-input v-model="detail.fcid" placeholder="" size="mini" class="dataForm__input" :disabled="true"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">特征名</div>
            <el-input v-model="detail.category" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopFeatureCategoryEdit">保存</div>
          <div class="gray-large-btn" @click="detailDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="创建属性" :visible.sync="attributeDialog" size="tiny" width="800px" center>
      <div class="flex fdr aic">
        <div class="dataForm">
          <div class="dataForm__item">
            <div class="dataForm__name">特征ID</div>
            <div>{{feature_attribute.fcid}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">特征名</div>
            <div>{{feature_attribute.category}}</div>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">权重</div>
            <el-input v-model="feature_attribute.weight" placeholder="" size="mini" class="dataForm__input"></el-input>
          </div>
          <div class="dataForm__item mt-20">
            <div class="dataForm__name">属性</div>
            <el-input type="textarea" v-model="feature_attribute.attributes" rows=4 placeholder="用|分割数据，例如37码|38码" size="mini" class="dataForm__input"></el-input>
          </div>
        </div>
      </div>
      <div class="flex fdc aic">
        <div class="flex mt-30">
          <div class="blue-large-btn mr-20" @click="shopFeatureAttributeMultiCreate">保存</div>
          <div class="gray-large-btn" @click="attributeDialog = false">取消</div>
        </div>
      </div>
    </el-dialog>
  </article>
</template>
<script>
import util from '../../../script/util'
import {shopFeatureCategoryLists, shopFeatureCategoryEdit, shopFeatureAttributeMultiCreate} from '../../../api/api'
import uploadHeadImage from '../../../components/uploadImage.vue'
export default {
  name: 'shopFeatureCategory',
  components: {
    uploadHeadImage
  },
  data () {
    return {
      lists: [],
      listLoading: false,
      detailDialog: false,
      attributeDialog: false,
      detail: {
        fcid: 0,
        category: ''
      },
      feature_attribute: {
        fcid: 0,
        weight: 0,
        category: '',
        attributes: ''
      }
    }
  },
  methods: {
    editDetail (index) {
      this.detailDialog = true
      for (let key in this.detail) {
        this.detail[key] = this.lists[index][key]
      }
    },
    editAttribute (index) {
      this.attributeDialog = true
      for (let key in this.detail) {
        this.feature_attribute[key] = this.lists[index][key]
      }
      this.feature_attribute.weight = 0
      this.feature_attribute.attributes = ''
    },
    shopFeatureAttributeMultiCreate () {
      let params = {
        fcid: this.feature_attribute.fcid,
        category: this.feature_attribute.category,
        weight: this.feature_attribute.weight,
        attributes: this.feature_attribute.attributes
      }

      let content = ''

      if (params['attributes'] === '') {
        content = '请填写属性'
      }

      if (content) {
        this.$notify({
          title: '失败',
          message: content,
          type: 'error'
        })
        return
      }

      shopFeatureAttributeMultiCreate(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.attributeDialog = false
          this.getList()

          for (let key in this.feature_attribute) {
            this.feature_attribute[key] = ''
          }
          this.feature_attribute.weight = 0
          this.feature_attribute.attributes = ''
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    shopFeatureCategoryEdit () {
      let params = {
        fcid: this.detail.fcid,
        category: this.detail.category
      }

      shopFeatureCategoryEdit(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.$notify({
            title: '成功',
            message: '保存成功',
            type: 'success'
          })
          this.detailDialog = false
          this.getList()

          for (let key in this.detail) {
            this.detail[key] = ''
          }
          this.detail.fcid = 0
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
      })
    },
    getList () {
      let params = {
      }

      this.listLoading = true
      shopFeatureCategoryLists(params).then((res) => {
        let data = res.data || {c: -1}
        if (!data.c) {
          this.lists = data.d.lists
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  },
  watch: {
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/shop/shopFeatureCategory.vue